export const environment = {
    production: true,
    staging: true,
    hmr: false,
    homologacao: false,
    url: "https://api.staging.sistemaprosper.com.br/api/v1/",
    server: "https://api.staging.sistemaprosper.com.br/",
    urlFront: "https://staging.sistemaprosper.com.br/",
    // Migração incremental para o front novo. Staging está atrás do Front Door (mesmo domínio),
    // então baseUrl é omitido (default "" = redirect relativo, o Front Door roteia /clientes/* ao
    // front novo). prod ainda não tem Front Door → migratedModules vazio lá.
    frontNovo: {
        migratedModules: ["clientes"],
    },
    publicKey: "BAyfbJL4qBeB5ykwayUrf25odTySqEePOq6pCaS6Th4bGNBhPNLTDxSNC97aGKsvNNuS6OzS-O5PzcKCrx38FUo",
    keyPusher: "d98e164731a66913ed89",
    SOCKET_ENDPOINT: "https://realtime.sistemaprosper.com.br:49160",
    SOCKET_TOKEN: "ayUrf25odTySqEePOq6pCaS6Th4",
    version: "3.1.0",
    sentry: {
        dsn: "https://ec13d5b59cef965c26a80a00d1daf743@o4509990372900864.ingest.de.sentry.io/4510064787718224",
        environment: "staging",
        release: "3.1.0-staging",
        // Staging: pode ser um pouco mais alto para debugging
        tracesSampleRate: 0.1, // 10% em staging
        replaysSessionSampleRate: 0.05, // 5% em staging
    },
};
